module.exports = __webpack_public_path__ + "static/img/icon-1-select.59ab0436.svg";